import { render, staticRenderFns } from "./matchtitle.vue?vue&type=template&id=cd06369a&"
import script from "./matchtitle.vue?vue&type=script&lang=js&"
export * from "./matchtitle.vue?vue&type=script&lang=js&"
import style0 from "./matchtitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports